import * as keys from './store-keys'
import Lockr from 'lockr'

export const SET_TOKEN = (state, token) => {
  state.token = token
  Lockr.set(keys.TOKEN, token)
}

export const SET_CURRENT_USER = (state, user) => {
  state.currentUser = user
  Lockr.set(keys.CURRENT_USER, user)
}

export const SET_LOADING = (state, loading) => {
  state.loading = loading
}



// WEBPACK FOOTER //
// ./src/store/mutations.js